import { whatIfInnerSelector, whatIfOptionsOrDefaultSelector } from '../../WhatIfsSelector';

export const principalSurvivorLivingExpensesSelector = (state, props) =>
  whatIfInnerSelector(state, props).PrincipalSurvivorLivingExpenses;
export const spouseSurvivorLivingExpensesSelector = (state, props) =>
  whatIfInnerSelector(state, props).SpouseSurvivorLivingExpenses;

export const principalNameSelector = (state, props) =>
  whatIfOptionsOrDefaultSelector(state, props).PrincipalName;

export const spouseNameSelector = (state, props) =>
  whatIfOptionsOrDefaultSelector(state, props).SpouseName;

export const hasSpouseSelector = (state, props) =>
  !!whatIfOptionsOrDefaultSelector(state, props).SpouseName;

export const survivorLivingExpensesOptionsSelector = (state, props) =>
  (whatIfOptionsOrDefaultSelector(state, props).SurvivorLivingExpensesOptions || [])
    .map(percentage => ({
      value: percentage,
      label: `${percentage}% of today's expenses`,
    }));
